import { SolValidationMessage } from '../models/core/sol-validation-message';

export class ValidationTools {
  /**
   * Return true if the given validation messages contain no errors.
   */
  public static isValid(messages: SolValidationMessage[]): boolean {
    return messages.filter(message => message.type === 'error').length === 0;
  }
}
